import { AccountUpdateTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

// This file includes different page types that all belong to the same flow (Account Update/Migration)

const AccountUpdateTrackingSchema: Record<
  AccountUpdateTrackingPoint,
  string
> = {
  [AccountUpdateTrackingPoint.MethodSelectionPageView]: '',
  [AccountUpdateTrackingPoint.MethodSelectionLinkEmailButtonClick]: '',
  [AccountUpdateTrackingPoint.MethodSelectionLinkPhoneButtonClick]: '',
  [AccountUpdateTrackingPoint.MethodSelectionSetUpLaterClick]: '',
  [AccountUpdateTrackingPoint.SkipAccountUpdateClick]:
    '446e0e4b-81bc-4984-ae9b-a125f757f7b1',
  [AccountUpdateTrackingPoint.LinkAccountPageView]:
    '4262836b-67e6-4324-8bfa-6575bf0b139b',
  [AccountUpdateTrackingPoint.LinkAccountBackButtonClick]: '',
  [AccountUpdateTrackingPoint.LinkAccountRequestSentPopupView]: '',
  [AccountUpdateTrackingPoint.LinkAccountRequestSentPopupOkButtonClick]: '',
  [AccountUpdateTrackingPoint.VerifyPhoneEmailButtonClick]:
    '1d1b2150-0dc5-4af8-83bc-407dcbb8a9a2',
  [AccountUpdateTrackingPoint.VerifyPhoneEmailButtonImpression]:
    '85205f29-b98c-4124-ab86-d7f1441b0d0e',
  [AccountUpdateTrackingPoint.ChangePhoneEmailButtonClick]:
    '54ab54c6-dee2-48f5-bf21-c77827fc1569',
  [AccountUpdateTrackingPoint.ChangePhoneEmailButtonImpression]:
    '25ce9622-99a4-48a5-a1ab-6ecfae1488fc',
  [AccountUpdateTrackingPoint.AddPhoneEmailButtonClick]:
    '1b274d99-f81e-425a-b5aa-42c813256b75',
  [AccountUpdateTrackingPoint.AddPhoneEmailButtonImpression]:
    '917be6af-8a99-45af-bdeb-c3ad3ffa9767',
  [AccountUpdateTrackingPoint.SetupLaterClick]:
    '0281985d-b8c0-4b52-ba62-d086cb1217d0',
  [AccountUpdateTrackingPoint.AccountLinkedSuccessPageView]:
    'a72566d1-5634-4b3f-a4f3-e613bfbb5a76',
  [AccountUpdateTrackingPoint.AccountLinkedSuccessAction]:
    '7a7e26fe-9469-4dda-b89e-80c8704dcc19',
  [AccountUpdateTrackingPoint.AccountLinkedTryNowButtonClick]:
    '169a2c7c-8f6d-4531-9f03-d4d1ce766090',
};

export const getAccountUpdateMethodSelectionPageTypeAndSchema = (
  trackingPoint: AccountUpdateTrackingPoint
) => {
  return {
    page_type: PageType.AccountUpdateMethodSelectionPage,
    schema: AccountUpdateTrackingSchema[trackingPoint],
  };
};

export const getAccountUpdateOverviewPageTypeAndSchema = (
  trackingPoint: AccountUpdateTrackingPoint
) => {
  return {
    page_type: PageType.AccountUpdateOverviewPage,
    schema: AccountUpdateTrackingSchema[trackingPoint],
  };
};

export const getAccountUpdateSuccessPageTypeAndSchema = (
  trackingPoint: AccountUpdateTrackingPoint
) => {
  return {
    page_type: PageType.AccountUpdateSuccessPage,
    schema: AccountUpdateTrackingSchema[trackingPoint],
  };
};
